import React from "react";
import { Helmet } from "react-helmet-async";
// import Landing from "./Landing";
import Content from "./Content";
import Landing from "../Esg/Landing";
import Content2 from "./Content2";
import Content3 from "./Content3";
import StartedWith from "../Esg/StartedWith";


const PartnerShip = () => {
  return (
    <>
      <Helmet>
        <title>ESG Memberships, Partnerships & UN Global Compact Participation | Nirantara</title>
        <meta name="description" content="Explore Nirantara's global ESG memberships and partnerships, including participation in the UN Global Compact and sustainability networks, driving collaborative action for responsible business." />
        <meta name="keywords" content="ESG partnerships, sustainability memberships, UN Global Compact participant, ESG network India, sustainability collaboration, responsible business network, ESG industry partnerships" />
        <link rel="canonical" href="https://nirantara.solutions/membership-and-partnership" />
      </Helmet>
      <Landing
        text={"Membership and\n Partnership"}
        image={"/assets/images/membership/membership-partnership.jpg"}

      />
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col-reverse md:grid md:grid-cols-1">
          <div className="flex flex-col justify-between w-full py-0 mx-auto text-white">
            <h1 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
              Building Bridges for Sustainable Impact
            </h1>
            <p className="mb-4 text-[#000000] text-lg leading-10">
              At Nirantara, we believe collaboration multiplies impact. Our memberships and partnerships connect us with global sustainability leaders, industry associations, regulatory bodies, and innovative organizations. Together, we advance Environmental, Social, and Governance (ESG) standards and drive meaningful change.
            </p>
          </div>
        </div>
      </section>
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col justify-between w-full py-0 mx-auto text-white">
          <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
            Our Participation
          </h2>
          <p className="mb-4 text-[#000000] text-lg leading-10">
            Proud participant of the UN Global Compact (UNGC), committed to responsible and sustainable business practices.
          </p>
        </div>
        <Content3 />
      </section>
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col md:grid md:grid-cols-1">
          <div className="flex flex-col justify-between w-full py-0 mx-auto text-white">
            <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
              Our Membership
            </h2>
            <p className="mb-4 text-[#000000] text-lg leading-10">
              Nirantara is an active member of leading national and international industry bodies that promote responsible business, sustainability innovation, and global collaboration.
            </p>
          </div>
          <Content />
        </div>
      </section>
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col justify-between w-full py-0 mx-auto text-white">
          <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
            Our Partnerships
          </h2>
          <p className="mb-4 text-[#000000] text-lg leading-10">
            Collaborating with leading institutions and industry partners to drive innovation, research, and sustainable solutions.
          </p>
        </div>
        <Content2 />
      </section>
      <StartedWith
        heading={"ESG Reporting & Compliance Assistance ?"}
        content1={"Partner with Nirantara to make your sustainability reporting credible, actionable, and aligned with global standards."}
        button1={"Contact Us"}
      />
    </>
  );
};

export default PartnerShip;
